// optionsConfig.ts
export const optionsConfig = {
    "napkin":
    {
        "color":
        [
            {name: "white",         hex: "#ECECE9",           tooltip: "White"},
            {name: "pistachio",     hex: "#AEC97B",           tooltip: "Pistachio"},
            {name: "lime",          hex: "#83B957",           tooltip: "Lime"},
            {name: "emerald",       hex: "#2A7C56",           tooltip: "Emerald"},
            {name: "chocolate",     hex: "#48392E",           tooltip: "Chocolate"},
            {name: "gold",          hex: "#9E7B45",           tooltip: "Gold"},
            {name: "mimosa",        hex: "#FBEB79",           tooltip: "Mimosa"},
            {name: "orange",        hex: "#E6753B",           tooltip: "Orange"},
            {name: "silver",        hex: "#AAAEAC",           tooltip: "Silver"},
            {name: "mint",          hex: "#81BDA9",           tooltip: "Mint"},
            {name: "pastelblue",    hex: "#7BBDCE",           tooltip: "Pastel Blue"},
            {name: "turquoise",     hex: "#1AAAC0",           tooltip: "Turquoise"},
            {name: "bermudablue",   hex: "#1A95B9",           tooltip: "Bermuda Blue"},
            {name: "cobalt",        hex: "#024CB5",           tooltip: "Cobalt"},
            {name: "navy",          hex: "#3E4766",           tooltip: "Navy"},
            {name: "purple",        hex: "#57497E",           tooltip: "Purple"},
            {name: "lavender",      hex: "#A995BE",           tooltip: "Lavender"},
            {name: "ivory",         hex: "#DDD2AB",           tooltip: "Ivory"},
            {name: "pink",          hex: "#F38AA6",           tooltip: "Pink"},
            {name: "magenta",       hex: "#C53467",           tooltip: "Magenta"},
            {name: "coral",         hex: "#F04440",           tooltip: "Coral"},
            {name: "red",           hex: "#BA383D",           tooltip: "Red"},
            {name: "burgundy",      hex: "#722B3D",           tooltip: "Burgundy"},
            {name: "black",         hex: "#323332",           tooltip: "Black"}
        ], 
        "quantity": 
        [
            100,
            150,
            200,
            250,
            300,
            350,
            400,
            450,
            500
        ],
        "orientation":
        [
            "square",
            "diamond"
        ]
    },
    "text": 
    {   
        "lineOne": "",
        "lineTwo": "",
        "font": 
        [
            {name:"Mayfair", size:"24px", maxChar:"22", singleLine:""},
            {name:"Goudy", size:"36px", maxChar:"20", singleLine:""},
            {name:"Lydian", size:"36px", maxChar:"20", singleLine:""},
            {name:"Florentine", size:"45px", maxChar:"18", singleLine:"A1|A8|A9|A10"},
        ],
    },
    "foil":{
        "color":
        [
           {name:"White", hex:"#E3E3E3" },
           {name:"Yellow", hex:"#DABA4D" },
           {name:"Pink", hex:"#E07FAA" },
           {name:"Red", hex:"#C52525" },
           {name:"Maroon", hex:"#671716" },
           {name:"Blue", hex:"#1D277E" },
           {name:"Navy", hex:"#11164D" },
           {name:"Green", hex:"#0C4019" },
           {name:"Gray", hex:"#696661" },
           {name:"Black", hex:"#1C1C1C" },
           {name:"Metallic Silver", hex:"#6D6D6D" },
           {name:"Metallic Gold", hex:"#936D0A" },
           {name:"Metallic Copper", hex:"#A24B08" },
           {name:"Metallic Red", hex:"#9C1114" },
           {name:"Metallic Lilac", hex:"#8F3B5C" },
           {name:"Metallic Magenta", hex:"#AC1D6D" },
           {name:"Metallic Purple", hex:"#652B53" },
           {name:"Metallic Blue", hex:"#1F3658" },
           {name:"Metallic Teal", hex:"#337760" } 
        ],
        "colortext":
        [
            "White", // "#E3E3E3",
            "Yellow", // "#DABA4D",
            "Pink", // "#E07FAA",
            "Red", // "#C52525",
            "Maroon", // "#671716",
            "Blue", // "#1D277E",
            "Navy", // "#11164D",
            "Green", // "#0C4019",
            "Gray", // "#696661",
            "Black", //[9] // "#1C1C1C",
            "Metallic Silver", // "#6D6D6D",
            "Metallic Gold", // "#936D0A",
            "Metallic Copper", // "#A24B08",
            "Metallic Red", // "#9C1114",
            "Metallic Lilac", // "#8F3B5C",
            "Metallic Magenta", // "#AC1D6D",
            "Metallic Purple", // #652B53",
            "Metallic Blue", // "#1F3658",
            "Metallic Teal" // "#337760",
        ]
    },
    "picture":{
        "images": 
        [//todo these might change according to the font icons
        {name: "a0"},
        {name:"a1"},    
        {name:"a2"},
        {name:"a3"},
        {name:"a4"},
        {name:"a5"},
        {name:"a6"},
        {name:"a7"},
        {name:"a8"},
        {name:"a9"},
        {name:"a10"}
    ]
    }    
    ,
    "ebayUser": ""
};

export default optionsConfig;
